import { getAppDisplayTimezone } from "./displayTimezone.js";

export function userTitle(u) {
  const name =
    (u?.name && u.name.trim()) ||
    [u?.first_name, u?.last_name].filter(Boolean).join(" ").trim();
  if (name) return name;
  if (u?.username) return `@${u.username}`;
  if (u?.id != null) return `id=${u.id}`;
  return "—";
}

export function fmtDt(iso, timeZone) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("ru-RU", {
      timeZone: timeZone || getAppDisplayTimezone(),
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(iso);
  }
}

/** Текущая дата в часовом поясе отдела (yyyy-mm-dd для форм). */
export function todayMoscowStr() {
  const parts = new Intl.DateTimeFormat("ru-CA", {
    timeZone: getAppDisplayTimezone(),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const y = parts.find((p) => p.type === "year").value;
  const m = parts.find((p) => p.type === "month").value;
  const d = parts.find((p) => p.type === "day").value;
  return `${y}-${m}-${d}`;
}

/** Диапазон «последние 7 дней» по Москве: { from, to } в формате yyyy-mm-dd. */
export function reportDefaultDateRange() {
  const to = todayMoscowStr();
  const [y, m, d] = to.split("-").map(Number);
  const fromDate = new Date(Date.UTC(y, m - 1, d - 6));
  return { from: formatDateForInput(fromDate), to };
}

/** yyyy-mm-dd for <input type="date"> (даты в Москве). */
export function formatDateForInput(d) {
  if (!d) return todayMoscowStr();
  const date = d instanceof Date ? d : new Date(d);
  const parts = new Intl.DateTimeFormat("ru-CA", {
    timeZone: getAppDisplayTimezone(),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const y = parts.find((p) => p.type === "year").value;
  const m = parts.find((p) => p.type === "month").value;
  const day = parts.find((p) => p.type === "day").value;
  return `${y}-${m}-${day}`;
}

